<section class="table-container" tabindex="0">
  <ng-scrollbar
    [track]="'all'"
    visibility="hover"
    [style.height]="tableHeight()"
    [style.width]="'100%'"
    (updated)="updateScrollBar()"
    #scrollbarRef
  >
    <ng-container *ngTemplateOutlet="tableTemplate"></ng-container>
  </ng-scrollbar>
</section>

<ng-template #tableTemplate>
  <table
    mat-table
    [dataSource]="dataSource() ?? []"
    matSort
    [class.use-horizontal-scroll]="useHorizontalScroll()"
    [class.interactive-table]="interactiveTable()"
    [class.cursor-table]="hasClickListener"
    [class.striped-table]="showStripes()"
    [trackBy]="trackById"
  >
    <ng-container *ngFor="let col of cols" [matColumnDef]="col.field" [stickyEnd]="col.frozenRight" [sticky]="col.frozenLeft">
      <th
        mat-header-cell
        *matHeaderCellDef
        mat-sort-header
        [ngClass]="col?.class"
        [style.maxWidth.px]="col.maxWidth || col.width"
        [style.minWidth.px]="col.minWidth || col.width"
        [disabled]="!col.sortable"
        [width]="col.width"
        [style.height]="headerHeight()"
      >
        <ng-container *ngIf="headerTemplate?.[col.field]; else defaultHeader">
          <div class="cell header-cell">
            <ng-container *ngTemplateOutlet="headerTemplate[col.field]"></ng-container>
          </div>
        </ng-container>
        <ng-template #defaultHeader>
          <div class="header-cell" [ngClass]="col.headerIcon ? 'has-icon' : ''">
            {{ col.header }}
            @if (col.headerIcon) {
              <u-icon
                [model]="col.headerIcon().model"
                [styles]="col.headerIcon().styles"
                [uTooltip]="col.headerIcon().uTooltip"
                [uTooltipPosition]="col.headerIcon().uTooltipPosition"
                [uTooltipClass]="col.headerIcon().uTooltipClass"
              ></u-icon>
            }
          </div>
        </ng-template>
      </th>
      <td
        mat-cell
        *matCellDef="let rowData; let index = index"
        [class]="col?.class"
        [style.maxWidth.px]="col.maxWidth || col.width"
        [style.minWidth.px]="col.minWidth || col.width"
        [width]="col.width"
        [style.height]="rowHeight()"
      >
        <div class="cell">
          @defer (on viewport) {
            <ng-container
              *ngTemplateOutlet="
                nodeTemplates[col.field] ? nodeTemplates[col.field] : defaultMaterialTemplate;
                context: { data: rowData, field: col.field, index }
              "
            >
            </ng-container>
          } @placeholder {
            <div></div>
          }
        </div>
      </td>
      <td mat-footer-cell *matFooterCellDef></td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true" [style.height]="headerHeight()"></tr>

    <tr
      (click)="setSelectedIndex($event, i, rowData)"
      mat-row
      *matRowDef="let rowData; columns: displayedColumns; let i = index"
      [class.selected]="i === selectedIndex()"
      [class]="'table-index-' + i"
      [style.height]="rowHeight()"
    ></tr>

    @if (displayEmptyState()) {
      <tr class="mat-mdc-row empty-state-row" *matNoDataRow>
        <td class="mat-mdc-cell" [attr.colspan]="displayedColumns.length">
          {{ emptyStateMessage() || 'No data available' }}
        </td>
      </tr>
    }

    <tr mat-footer-row *matFooterRowDef="displayedColumns; sticky: true" class="scroll-spacer-footer"></tr>
  </table>
</ng-template>
<ng-template #defaultMaterialTemplate let-data="data" let-field="field">
  <u-truncate-text [text]="data[field]"> </u-truncate-text>
</ng-template>
